import {api} from "../../../system/api";
import {PREFIX_URL} from "../../../system/api/constants";

export default {
    getScopes: project_id => api.get(PREFIX_URL.PROJECT + `/${project_id}/ticket-scopes`),
    updateScope: (scopeId, params) => api.put(`/ticket-scopes/${scopeId}`, params),
    updatePosition: (project_id, params) => api.put(PREFIX_URL.PROJECT + `/${project_id}/ticket-scopes/positions`, params),
    createScope: (projectId, params) => api.post(`/projects/${projectId}/ticket-scopes`, params),
}
